// client/src/services/pollsService.js
import { api } from './api';
import { localPollsService } from './localPollsService';

// Use environment variable to determine which implementation to use
const USE_LOCAL_STORAGE = process.env.REACT_APP_USE_LOCAL_STORAGE === 'true';

export const pollsService = USE_LOCAL_STORAGE 
  ? localPollsService 
  : {
      getAllPolls: async () => {
        try {
          const response = await api.getAllPolls();
          return response;
        } catch (error) {
          console.error('Error fetching polls:', error);
          throw error;
        }
      },

      getPoll: async (pollId) => {
        try {
          const response = await api.getPoll(pollId);
          return response;
        } catch (error) {
          // console.error(`Error fetching poll ${pollId}:`, error);
          throw error;
        }
      },

      createPoll: async (question) => {
        try {
          const response = await api.createPoll({ question });
          return response;
        } catch (error) {
          // console.error('Error creating poll:', error);
          throw error;
        }
      },

      deletePoll: async (pollId) => {
        try {
          const response = await api.deletePoll(pollId);
          return response;
        } catch (error) {
          // console.error('Error deleting poll:', error);
          throw error;
        }
      }
    };